import { isEmpty } from 'lodash';
import Box from '@mui/material/Box';
import { FormProvider } from 'react-hook-form';
import React, { useEffect } from 'react';

import FormContainer from 'core/forms/FormContainer';
import Spacer from 'core/spacer/Spacer';
import Button from 'core/buttons/Button';

import Stepper from './StepperForm/Stepper';

function RolesAndPermissionForm(props) {
  const {
    steps,
    methods,
    onSubmit,
    isAddMode = true,
    defaultValues,
    isSubmitting,
    onCancel,
    fieldErrors,
    activeStep,
    nextStep,
    previousStep,
    onStepSubmit,
    stepProps = {},
  } = props;

  const {
    setErrors,
    formState: { errors },
    getValues,
  } = methods;

  const isFirstStep = activeStep === 0;
  const isLastStep = activeStep === steps.length - 1;

  useEffect(() => {
    if (!isEmpty(fieldErrors)) {
      setErrors(fieldErrors);
    }
  }, [fieldErrors, setErrors]);

  const validateCurrentStep = async () => {
    const schema = steps[activeStep].schema;
    if (!schema) return true;
    const values = getValues();
    return schema.validate(values, { abortEarly: false }).then(
      () => true,
      (err) => {
        if (err.inner) {
          err.inner.forEach((e) => {
            methods.setError(e.path, { message: e.message });
          });
        }
        return false;
      },
    );
  };

  const handleNext = async () => {
    const valid = await validateCurrentStep();
    if (!valid) return;
    if (onStepSubmit) {
      onStepSubmit(activeStep, getValues());
      return;
    }
    nextStep();
  };

  const onFormSubmit = (data) => {
    onSubmit(isAddMode ? data : data);
  };

  const currentStepConfig = steps[activeStep] || {};
  const StepElement = currentStepConfig.element;

  return (
    <FormContainer>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onFormSubmit)}>
          <Box display="flex" flexDirection="column">
            <Box sx={{ width: '100%', mb: 3 }}>
              <Stepper activeStep={activeStep} steps={steps} errors={errors} />
            </Box>
            <Box sx={{ flex: 1 }}>
              {StepElement &&
                React.createElement(StepElement, {
                  isAddMode,
                  ...(stepProps[activeStep] || {}),
                })}
              <Spacer height="24px" />

              <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap={1}>
                {isFirstStep ? (
                  <Button type="button" variant="outlined" onClick={() => onCancel?.()}>
                    Cancel
                  </Button>
                ) : (
                  <Button type="button" variant="outlined" onClick={previousStep}>
                    Back
                  </Button>
                )}
                {isLastStep ? (
                  <Button type="submit" variant="contained" disabled={isSubmitting}>
                    {isAddMode ? 'Create Role' : 'Update Role'}
                  </Button>
                ) : (
                  <Button
                    type="button"
                    variant="contained"
                    onClick={handleNext}
                    disabled={isSubmitting}
                  >
                    Next
                  </Button>
                )}
              </Box>
            </Box>
          </Box>
        </form>
      </FormProvider>
    </FormContainer>
  );
}

export default RolesAndPermissionForm;
